export default __webpack_public_path__ + "static/media/_DSC0504.b6be44a0.jpg";